import { GameOverLayer } from './../GameOverLayer';
import { GameVars } from "./../../../GameVars";
import { GameConstants } from "./../../../GameConstants";

export class TopInfo extends Phaser.GameObjects.Container {

    private hands: Phaser.GameObjects.Text;
    private blinds: Phaser.GameObjects.Text;
    private nextBlinds: Phaser.GameObjects.Text;

    private potText: Phaser.GameObjects.Text;
    private potCartridge: Phaser.GameObjects.Graphics;
    private chipIconPotLabel: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene) {

        super(scene);

        this.x = GameConstants.GAME_WIDTH / 2;
        this.scaleX = GameVars.scaleX;

        this.hands = new Phaser.GameObjects.Text(this.scene, -345, 35, "", {fontFamily: "Oswald-Medium", fontSize: "25px", color: "#ffffff"});
        this.hands.setOrigin(0, .5);
        this.add(this.hands);

        this.blinds = new Phaser.GameObjects.Text(this.scene, -225, 35, "", {fontFamily: "Oswald-Medium", fontSize: "25px", color: "#ffffff"});
        this.blinds.setOrigin(0, .5);
        this.add(this.blinds);

        this.nextBlinds = new Phaser.GameObjects.Text(this.scene, -45, 35, "", {fontFamily: "Oswald-Medium", fontSize: "25px", color: "#ffffff"});
        this.nextBlinds.setOrigin(0, .5);
        this.add(this.nextBlinds);

        const h = 40;

        const potContainer = new Phaser.GameObjects.Container(this.scene, (- (GameConstants.GAME_WIDTH / 2) + 5) / GameVars.scaleX, 75);
        this.add(potContainer);

        this.potCartridge = new Phaser.GameObjects.Graphics(this.scene);
        potContainer.add(this.potCartridge);

        this.potText = new Phaser.GameObjects.Text(this.scene, 15, h / 2, "POT: " + GameVars.gameState.pot, {fontFamily: "Oswald-Medium", fontSize: "25px", color: "#ffffff"});
        this.potText.setOrigin(0, .5);
        potContainer.add(this.potText);

        const w = this.potText.width + 55;

        this.potCartridge.fillStyle(0x000000, .5);
        this.potCartridge.fillRoundedRect(0, 0, w, h, h / 2);

        this.chipIconPotLabel = new Phaser.GameObjects.Image(this.scene, this.potText.x + this.potText.width + 5, h / 2 + 1, "texture_atlas_1", "chip_pot_icon.png");
        this.chipIconPotLabel.setScale(.8);
        this.chipIconPotLabel.setOrigin(0, .5);
        potContainer.add(this.chipIconPotLabel);

        if (GameConstants.SPONSOR === GameConstants.SPONSOR_FUNO) {
            this.x -= 80;
            potContainer.x += 80;
        }

        this.updateInfo();
    }

    public updateInfo(): void {

        this.hands.setText("HAND: " + GameVars.gameState.hand);
        this.blinds.setText("BLINDS: " + GameVars.gameState.bigBlind + "/" + GameVars.gameState.smallBlind);

        let nextBB: number;
        let nextSB: number;

        if (GameVars.blindsPosition < GameConstants.BIG_BLINDS.length) {
            nextBB = GameConstants.BIG_BLINDS[GameVars.blindsPosition + 1];
            nextSB = GameConstants.BIG_BLINDS[GameVars.blindsPosition + 1] / 2;
            this.nextBlinds.setText("NEXT BLINDS: " + nextBB + "/" + nextSB + " (IN " + (10 - GameVars.gameState.hand % 10) + " HANDS)");
        } else {
            this.nextBlinds.setText("");
        }

    }

    public updatePot(): void {

        let pot = 0;

        let players = GameVars.gameState.players;

        for (let i = 0; i < players.length; i++) {
            pot += players[i].wagered;
            pot += players[i].poted;
        }

        this.potText.setText("POT: " + pot);

        const w = this.potText.width + 55;
        const h = 40;

        this.potCartridge.clear();
        this.potCartridge.fillStyle(0x000000, .5);
        this.potCartridge.fillRoundedRect(0, 0, w, h, h / 2);

        this.chipIconPotLabel.x = this.potText.x + this.potText.width + 5;
    }
}
